/**
 * learning_prompt banner row (plan 15.5, 16.4; tse_learning_prompt.schema.json; banner design doc section 5).
 * The same banner as the feedback row: text and at most one button, nothing else.
 * Variants: learned (button opens the popover's Learning tab), teach (opens the panel where the cause is
 * taught), sent and off (no button, announced once with role=status). The enterprise variant never
 * renders it (the caller suppresses it, like the feedback row).
 */
import React from "react";

export const LEARNING_PROMPT_VARIANTS = Object.freeze({ LEARNED: "learned", TEACH: "teach", SENT: "sent", OFF: "off" });
export const QUOTE_MAX_CHARS = 60;
const STATUS_VARIANTS = new Set([LEARNING_PROMPT_VARIANTS.SENT, LEARNING_PROMPT_VARIANTS.OFF]);

export const truncateQuote = (text, max = QUOTE_MAX_CHARS) => {
  const s = String(text || "").trim();
  return s.length > max ? `${s.slice(0, max - 1).trimEnd()}…` : s;
};

/** The learned sentence with cause and fix quoted and truncated; the full text goes in the title. */
function learnedText(msg) {
  if (!msg.cause) return msg.text;
  const fix = msg.fix ? ` and “${truncateQuote(msg.fix)}”` : "";
  return `Learned “${truncateQuote(msg.cause)}”${fix} for this symptom set.`;
}

export default function LearningPromptRow({ msg, onOpenTab }) {
  const variant = msg.variant;
  const isStatus = STATUS_VARIANTS.has(variant);
  const text = variant === LEARNING_PROMPT_VARIANTS.LEARNED ? learnedText(msg) : msg.text;
  const button = msg.button && !isStatus ? msg.button : null;

  return (
    <div
      className={`d5-feedback-prompt-row d5-lp-row d5-lp-row--${variant}`}
      data-testid="learning-prompt-row"
      data-variant={variant}
      role={isStatus ? "status" : undefined}
    >
      <span className="d5-feedback-prompt-text d5-lp-text" title={msg.text}>{text}</span>
      {button && (
        <button
          type="button"
          className={variant === LEARNING_PROMPT_VARIANTS.TEACH ? "d5-lp-btn d5-lp-btn--ghost" : "d5-feedback-prompt-btn d5-lp-btn"}
          onClick={() => onOpenTab?.(msg)}
        >
          {button.label}
        </button>
      )}
    </div>
  );
}
